module.exports = __webpack_public_path__ + "static/king_gekaton-1d857e6920317bad1008af1246918b5c.jpg";